import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#1B1A55",
    },
    secondary: {
      main: "#ffeb3b",
    },
  },
  typography: {
    fontFamily: "open sans",
    fontWeight: "bold",
  },
  button: {
    fontFamily: "open sans",
    fontWeight: "bold",
  },
  textFiled: {
    height: "20px",
    fontFamily: "open sans",
  },
  text: {
    fontFamily: "open sans",
    fontWeight: "bold",
  },
  span: {
    fontFamily: "open sans",
    fontWeight: "bold",
  },
  p: {
    fontFamily: "open sans",
    fontWeight: "bold",
  },
});
export default theme;
